module.exports = __webpack_public_path__ + "media/images/wfc/venue-2-ec6029694c792a744fc5dadfb8e45d05.jpg";